import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { apiUrl } from '@/constants/config'

const state = () => ({
  uploadedFiles: [],
  isLoading: false
})

const getters = {
  uploadedFiles: (state) => state.uploadedFiles,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_UPLOADED_FILES(state, payload) {
    state.uploadedFiles = payload
  },
  CHANGE_UPLOADED_FILES(state, payload) {
    payload.map((path) => (state.uploadedFiles = [...state.uploadedFiles, path]))
  },
  DELETE_UPLOADED_FILES(state, index) {
    state.uploadedFiles = state.uploadedFiles.filter((_, i) => i !== index)
  },
  RESET_UPLOADS(state) {
    state.uploadedFiles = []
    state.isLoading = false
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  uploadImage(_context, { blobInfo, success, failure, progress }) {
    const data = new FormData()
    data.append('file', blobInfo.blob(), blobInfo.filename())

    axiosWithToken
      .post(`${adminBaseUrl}/file_manager/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          progress(percentCompleted)
        }
      })
      .then((res) => {
        const data = res.data.message

        if (!data || typeof data != 'string') {
          failure('Invalid JSON:')
          return
        }

        success(`${apiUrl}/${data}`)
      })
      .catch((err) => {
        const status = err.response.status

        if (status === 403) {
          failure('HTTP Error: ' + status, { remove: true })
          return
        }

        if (status < 200 || status >= 300) {
          failure('HTTP Error: ' + status)
        }
      })
  },
  async uploadFiles({ commit, dispatch }, files) {
    commit('SET_LOADING', true)
    try {
      const data = new FormData()
      for (const file of files) {
        data.append('files[]', file)
      }
      const res = await axiosWithToken.post(`${adminBaseUrl}/file-manager/multiple-upload`, data)
      commit('CHANGE_UPLOADED_FILES', res.data.data)
    } catch (err) {
      dispatch('auth/requestAuthError', err, { root: true })
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async deleteFile({ commit, dispatch }, { file, callback }) {
    commit('SET_LOADING', true)
    try {
      await axiosWithToken.post(`${adminBaseUrl}/file-manager/delete`, {
        file_path: file.url
      })

      callback()
    } catch (err) {
      dispatch('auth/requestAuthError', err, { root: true })
    } finally {
      commit('SET_LOADING', false)
      commit('DELETE_UPLOADED_FILES', file.index)
    }
  },
  resetUploads({ commit }) {
    commit('RESET_UPLOADS')
  },
  editUploads({ commit }, paths) {
    commit('SET_UPLOADED_FILES', paths)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
